import React from 'react';
import { useTranslation } from 'react-i18next';
import Navbar from './home/Navbar';
import Footer from './Footer';
import { useNavigate } from 'react-router-dom';

function DemoEasyApp() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const useCases = t('demo_easyapp.use_cases', { returnObjects: true });

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="flex flex-col min-h-screen bg-ink font-sans text-white antialiased">
      <Navbar />
      
      {/* Sección 1: Video */}
      <section className="w-full bg-ink pt-28 pb-16">
        <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold mb-8 text-white">{t('demo_easyapp.title')}</h2>
          <div className="w-full aspect-video rounded-2xl overflow-hidden border border-line shadow-2xl">
            <video 
              className="w-full h-full object-cover"
              controls
              autoPlay={true}
            >
              <source src="/videoeasyappdemo.mp4" type="video/mp4" />
              {t('demo_easyapp.video_not_supported')}
            </video>
          </div>
        </div>
      </section>

      {/* Sección 6: Cómo funciona */}
      <section className="w-full bg-surface py-16">
        <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold mb-8 text-white">{t('demo_easyapp.about_title')}</h2>
          
          <div className="space-y-8">
            <div className="bg-elevated border border-line p-8 rounded-xl">
              <p className="text-lg text-white/70 mb-6">
                {t('demo_easyapp.description_1')}
              </p>

              <p className="text-lg text-white/70 mb-8">
                {t('demo_easyapp.description_2')}
              </p>

              <div className="mb-8">
                <h3 className="text-xl font-semibold mb-4 text-white">{t('demo_easyapp.use_cases_title')}</h3>
                <p className="text-white/70 mb-4">{t('demo_easyapp.use_cases_description')}</p>
                <ul className="space-y-3 text-white/70">
                  {useCases.map((useCase, index) => (
                    <li key={index} className="flex items-start">
                      <span className="text-accent-400 mr-2">•</span>
                      {useCase}
                    </li>
                  ))}
                </ul>
              </div>

              <div className="bg-surface border border-line p-6 rounded-lg">
                <p className="text-white/70">
                  {t('demo_easyapp.contact_text')}{' '}
                  <a href="mailto:contacto@easyappforz.com" className="text-accent-400 hover:underline">
                    contacto@easyappforz.com
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Sección 7: Precios */}
      <section className="w-full bg-ink py-16">
        <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold mb-8 text-white">{t('demo_easyapp.pricing_title')}</h2>
          <div className="bg-elevated border border-line p-8 rounded-2xl">
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6">
              <div>
                <h3 className="text-2xl font-bold text-white mb-2">{t('demo_easyapp.price_label')}</h3>
                <div className="flex items-baseline gap-2">
                  <span className="text-4xl font-bold text-white">$3.50</span>
                  <span className="text-white/50">{t('demo_easyapp.per_agent_month')}</span>
                </div>
              </div>
              <div className="flex flex-col md:flex-row gap-6">
                <a 
                  href="https://www.zendesk.com/in/marketplace/apps/support/1104791/easyapp/?queryID=ef8c46b9f3fecd2ce6f85d079873c531"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block w-full md:w-auto px-8 py-3 bg-cta text-ink font-semibold rounded-lg hover:bg-cta-hover transition-colors duration-300 text-center"
                >
                  {t('demo_easyapp.start_trial_button')}
                </a>
                <button 
                  onClick={() => navigate('/', { state: { scrollTo: 'contact' } })}
                  className="w-full md:w-auto px-8 py-3 border border-line text-white font-medium rounded-lg hover:bg-white/5 transition-colors duration-300"
                >
                  {t('demo_easyapp.schedule_demo_button')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default DemoEasyApp;